import type { TileGridFeedItem } from "../feedTypes.js";
import type { FeedCardComponentProps } from "../FeedRenderer.js";

interface TileGridCardProps extends FeedCardComponentProps {
  item: TileGridFeedItem;
}

export function TileGridCard({ item, data, onAction }: TileGridCardProps) {
  return (
    <div className="feed-card-tiles">
      {item.config.tiles.map((tile) => (
        <button
          key={tile.id}
          type="button"
          className="feed-card-tile"
          onClick={() => onAction(tile.action, { itemId: item.id, source: "tile", data })}
        >
          <div className="feed-card-tile-header">
            {tile.icon && <span className="feed-card-tile-icon" aria-hidden>{tile.icon}</span>}
            <span className="feed-card-tile-label">{tile.label}</span>
          </div>
          {tile.description && <p className="feed-card-tile-description">{tile.description}</p>}
          {tile.badge && <span className="feed-card-tile-badge">{tile.badge}</span>}
        </button>
      ))}
    </div>
  );
}
